var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlansDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.318,
    viewBox: "0 0 18 18.318",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160660",
    "data-name": "Group 160660",
    transform: "translate(-408.421 -159.682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160578",
    "data-name": "Group 160578",
    transform: "translate(408.421 160)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plans_Outline_24px",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1094",
    "data-name": "Rectangle 1094",
    width: 18,
    height: 18,
    fill: "#165cf3",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M17.614,16.65a1.729,1.729,0,0,1-1.729,1.729H4.769A1.729,1.729,0,0,1,3.04,16.65V3.719A1.729,1.729,0,0,1,4.769,1.99H15.886a1.729,1.729,0,0,1,1.729,1.729V12.84",
    transform: "translate(-1.746 -1.558)",
    fill: "#adc7ff",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3222",
    "data-name": "Group 3222",
    transform: "translate(6.706 3.615)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3221",
    "data-name": "Group 3221",
    transform: "translate(1.79)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    y2: 0.895,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    y2: 0.961,
    transform: "translate(0.016 6.283)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M12.919,7.79H10.693a1.035,1.035,0,1,0,0,2.07h1.478a1.035,1.035,0,1,1,0,2.07H9.65",
    transform: "translate(-9.65 -6.221)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1095",
    "data-name": "Rectangle 1095",
    width: 1.232,
    height: 1.232,
    rx: 0.36,
    transform: "translate(3.668 13.175)",
    fill: "#f49b31"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1096",
    "data-name": "Rectangle 1096",
    width: 7.597,
    height: 1.232,
    rx: 0.616,
    transform: "translate(5.914 13.175)",
    fill: "#f49b31"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_122",
    "data-name": "Ellipse 122",
    cx: 0.468,
    cy: 0.468,
    r: 0.468,
    transform: "translate(15.4 12.708)",
    fill: "#165cf3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlansDarkIcon);
export default __webpack_public_path__ + "static/media/plans-dark-icon.0106a5df51a866f288cd7ba1329a5ae2.svg";
export { ForwardRef as ReactComponent };